import { Sprite, Graphics, Renderer, Container } from 'pixi.js';

import { PLAYER_RADIUS } from '../constants';

export const createCursorDirectionIndicator = (renderer: Renderer, fillColor: number): Container => {
  const TRIANGLE_SIZE = 35;

  const cursorContainer = new Container();
  cursorContainer.interactiveChildren = false;
  cursorContainer.eventMode = 'none';
  cursorContainer.name = 'cursor-indicator-container';

  const indicatorGraphics = new Graphics();
  indicatorGraphics.beginFill(fillColor);
  indicatorGraphics.drawCircle(0, 0, PLAYER_RADIUS);
  indicatorGraphics.endFill();
  const texture = renderer.generateTexture(indicatorGraphics);
  const cursorIndicator = new Sprite(texture);

  cursorContainer.addChild(cursorIndicator);

  cursorIndicator.anchor.set(0.5, 0.5);
  cursorIndicator.name = 'direction-indicator';

  // Triangle graphics
  const directionIndicator = new Graphics();
  directionIndicator.beginFill(fillColor);
  directionIndicator.drawRect(0, 0, TRIANGLE_SIZE, TRIANGLE_SIZE);
  directionIndicator.endFill();

  // Triangle sprite: Necessary to apply rotation, graphics works with pivot which is kind of tricky
  const directionContainerTexture = renderer.generateTexture(directionIndicator);
  const indicatorSprite = new Sprite(directionContainerTexture);
  indicatorSprite.name = 'direction-indicator-triangle';
  indicatorSprite.anchor.set(0.5, 0.5);
  indicatorSprite.angle = 45;

  // Finding the exact x value to match square corners with circle bounds. -> x = sqrt(r^2 - y^2)
  // Square diagonal length = side length * sqrt(2)
  const triangleHeight = (TRIANGLE_SIZE * Math.sqrt(2)) / 2;
  const triangleX = Math.sqrt(PLAYER_RADIUS * PLAYER_RADIUS - triangleHeight * triangleHeight);
  indicatorSprite.position.set(triangleX, 0);

  cursorContainer.addChild(indicatorSprite);
  return cursorContainer;
};
